import React from 'react';
import { Badge, Flex, Text } from '@mantine/core';
import PropTypes from 'prop-types';
import { getCustomerTypeBadge } from '../../../utils/customerTypeBadge';

const CustomerTypeList = ({ customerTypes }) => {
  return(
    <div>
      {customerTypes?.map((type, index) => {
        const badge = getCustomerTypeBadge(type.sourceTypeId);

        return (
          <Flex align="center" gap="xs" key={index} >
            <Text  mb={5} pl={index === 0 ? 0 : 7}>
              {index === 0 && ':'} {type.name}
            </Text>
            <Badge
              bg={badge.backgroundColor}
              c={badge.textColor}
              fw={500}
              radius="xl"
              style={{ textTransform: 'none' }}
            >
              {badge.label}
            </Badge>
          </Flex>
        );
      })}
    </div>
  );
};

export default CustomerTypeList;

CustomerTypeList.propTypes = {
  customerTypes: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    sourceTypeId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  })),
};
